module.exports = __webpack_public_path__ + "static/image7_mobile@2x-c996c1ab3d47e3c53e6d6d8e23135e0c.png";